/*
 * Copyright (c) 2022-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { TokenReplacement } from 'src/types';

import { loc } from '../../../util';

export const getEmailAuthenticatorSubtitle = (
  emailAddress: unknown | undefined,
  secondaryEmailAddress: unknown | undefined,
  useEmailMagicLink: boolean,
  tokenReplacement?: TokenReplacement,
): string => {
  const getPrefixText = () => {
    if (typeof secondaryEmailAddress !== 'undefined' && typeof emailAddress !== 'undefined') {
      return loc('oie.email.verify.alternate.magicLinkToEmailAddress.with.secondary.email', 'login', [emailAddress, secondaryEmailAddress], tokenReplacement);
    }

    if (typeof emailAddress !== 'undefined') {
      return loc('oie.email.verify.alternate.magicLinkToEmailAddress', 'login', [emailAddress], tokenReplacement);
    }

    return loc('oie.email.verify.alternate.magicLinkToYourEmail', 'login');
  };

  const instructionPostfixText = useEmailMagicLink
    ? loc('oie.email.verify.alternate.instructions', 'login')
    : loc('oie.email.verify.alternate.verificationCode.instructions', 'login');

  return `${getPrefixText()}${instructionPostfixText}`;
};
